import { render, staticRenderFns } from "./Icon-1.vue?vue&type=template&id=18be51e2&scoped=true"
import script from "./Icon-1.vue?vue&type=script&lang=js"
export * from "./Icon-1.vue?vue&type=script&lang=js"
import style0 from "./Icon-1.vue?vue&type=style&index=0&id=18be51e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be51e2",
  null
  
)

export default component.exports